import { PublishedWinnerProps } from "./types";
import styles from "./winners.module.css";
import PrizeUrl from "./prizeUrl";
import Link from "next/link";
import { useContext } from "react";
import { CurrentPageContext } from "./winners-context";

const PublishedWinner = ({
  position,
  playedWinnerVideoPosition,
  setPlayedWinnerPosition,
  winnerVideo,
  winnerPhoto,
  winnerName,
  competitionDateRange,
  prize,
  competitionType,
  competitionPictureTitle,
  numberOfInstantWins,
  winnerDetailsLink,
  isInstantWinCompetition,
  winnerMobilePhoto,
  LinkedCollectionUrl,
  dealer,
  CompetitionRef,
}: PublishedWinnerProps) => {
  const isWinnersPage = useContext(CurrentPageContext);
  let competitionDetailsText;
  if (isWinnersPage) {
    competitionDetailsText = isInstantWinCompetition
      ? "Instant Win Results"
      : `${competitionPictureTitle ?? ""} Winner - ${winnerName}`;
  } else {
    competitionDetailsText = winnerName;
  }

  const getDetailsLink = () => {
    if (isWinnersPage) {
      return winnerDetailsLink;
    }
    return LinkedCollectionUrl ? LinkedCollectionUrl : `/winners/${CompetitionRef}`;
  };

  return (
    <>
      <div className={`flex justify-center items-center relative ${styles.publishedWinnerContainer}`}>
        <div className={`absolute invisible ${styles.publishedWinnerBackdrop}`}></div>
        <picture>
          <source media="(max-width: 600px)" srcSet={winnerMobilePhoto} />
          <img
            src={winnerPhoto}
            alt={winnerName}
            loading={position === 0 || position === 1 ? "eager" : "lazy"}
            className={`${position === playedWinnerVideoPosition ? "invisible" : "visible"} h-auto max-w-full border-[3px] border-solid border-[#e7e7e7]`}
          />
        </picture>
        {position === playedWinnerVideoPosition && (
          <>
            <iframe
              data-testid={`youtube-iframe-${position}`}
              style={{ height: "100%", width: "100%", position: "absolute" }}
              src={`https://www.youtube-nocookie.com/embed/${winnerVideo}`}
              allowFullScreen></iframe>
            <button
              data-testid={`winner-video-close-${position}`}
              onClick={() => setPlayedWinnerPosition(-1)}
              className={`flex z-10 ${styles.btnCloseYoutubeVid}`}>
              CLOSE
              <img src={"/assets/images/select-cross-orange.png"} alt="close-youtube" />
            </button>
          </>
        )}
        {position !== playedWinnerVideoPosition && (
          <>
            {winnerVideo !== "" && !winnerVideo.startsWith("https://") && (
              <button className="z-10 absolute">
                <img
                  data-testid={`winner-video-${position}`}
                  src={"/assets/images/video-play.png"}
                  width={64}
                  height={64}
                  alt="play video icon"
                  onClick={() => setPlayedWinnerPosition(position)}
                />
              </button>
            )}
          </>
        )}
      </div>
      <p data-testid={`winner-${position}`} className={styles.winnerNamePara}>
        {competitionDetailsText}
      </p>
      <PrizeUrl {...{ competitionPictureTitle, competitionType, prize }} />
      <p data-testid="competitionDateRange" className={styles.competitionDateRangePara}>
        {isWinnersPage ? competitionDateRange : dealer}
      </p>
      {numberOfInstantWins > 0 && (
        <p className={`justify-center ${styles.instantWinPara}`}>
          This competition had {numberOfInstantWins.toLocaleString()}
          <img
            src={"/assets/images/winners/instant-win.svg"}
            alt="instantWin"
            className="mx-1 inline"
            width={10}
            height={17}
          />
          <span className="text-[#ff8200] font-bold">Instant Wins</span>
        </p>
      )}
      <div className="mt-[1.75em] flex justify-center">
        <Link
          href={getDetailsLink()}
          className="w-80 lg:text-[16px] xs:text-[14px] font-jost relative flex justify-center items-center bg-[#FF8200] hover:bg-[#FF6A00] text-white font-semibold hover:text-white border border-orange-500 hover:border-transparent rounded btnWithArrow pr-[34px] pl-4 py-4">
          {isWinnersPage ? "VIEW FULL RESULTS" : "VIEW COLLECTION"}
          <img
            className="arrowImage absolute left-[74%]"
            src="/assets/images/chevron.png"
            alt="view full results"
            width={10}
            height={10}
          />
        </Link>
      </div>
    </>
  );
};

export default PublishedWinner;
